export default __webpack_public_path__ + "734e4ba2385f675fd09039b49a4131ad.png";